<template>

    <tr>
        <td class="text-left" :class="{active: objMenOpen || inputFocused}" style="vertical-align: middle; white-space: nowrap;">
            <v-tooltip bottom color="rgba(48, 48, 48, 1.0)">
                <template v-slot:activator="{ on }">
                    <span style="color: #ffffff;" v-on="on"><b>{{$props.node.node_name}}</b></span>
                </template>
                <span v-if="$props.node.node_description">{{$props.node.node_description}}</span>
            </v-tooltip>
        </td>

        <td class="text-left" :class="`node-${this.$props.node.node_id}`" style="vertical-align: middle; white-space: nowrap; width: 100%;">

            <template v-if="$props.edit">
                <!-- Here is where we would enforce data type validation(dropdown, objects, etc...) -->
                <v-text-field v-model="value.node_value" :class="classObject" outlined color="#FFFF99" @focus="inputFocused = true" @blur="inputFocused = false" :readonly="value.item_id != -1" clearable @click:clear="nodeInputClearButtonClick">
                    <template v-slot:prepend-inner>
                        <v-menu style="top: -12px" offset-y :close-on-content-click="false" v-model="objMenOpen">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon style="margin-top: -3px;" :class="{'item-set': value.item_id != -1}" v-bind="attrs" v-on="on">mdi-cube-outline</v-icon>
                            </template>
                            <common-object-item-picker :nodeValue="value" :commonObjects="$props.commonObjects" @cancel="objMenOpen = false" @item="setValueToCommonObjectItem" @clear="clearCommonObjectItem" v-if="objMenOpen" />
                        </v-menu>
                    </template>
                </v-text-field>

            </template>

            <template v-else>
                <template v-if="$props.node.value && $props.node.value.item_id == -1">{{getNodeRawValue($props.node)}}</template>
                <template v-else-if="$props.node.value && $props.node.value.item_id != -1">
                    <v-menu offset-x :close-on-content-click="false" right nudge-right="15">
                        <template v-slot:activator="{ on, attrs }">
                            <span class="sitebook-node-item-value" v-bind="attrs" v-on="on">{{getNodeItemValue($props.node)}}</span>
                        </template>
                        <common-object-item-info :nodeValue="value" :objectId="value.object_id" :itemId="value.item_id" :commonObjects="$props.commonObjects" />
                    </v-menu>
                </template>
                <template v-else></template>
            </template>

        </td>
        <td class="text-left" style="vertical-align: middle; min-width: 100px;" v-if="!$props.edit">
            <span class="node-files-text" @click="openNodeFileBank" v-if="$props.node.files.length">
                <v-icon class="node-files" v-if="$props.node.files.length">{{`${$props.node.files.length > 1 ? 'mdi-file-multiple': 'mdi-file'}`}}</v-icon>
                {{`x${$props.node.files.length}`}}
            </span>
            <span class="node-files-text" @click="openNodeFileBank" v-else>
                <v-icon class="ml-1 node-files" v-if="!$props.lockSave">mdi-plus-circle-outline</v-icon>
            </span>
        </td>
        <v-divider />

    </tr>

</template>

<script>
import CommonObjectItemPicker from "@/components/Sites/CommonObjectItemPicker";
import CommonObjectItemInfo from "@/components/Sites/CommonObjectItemInfo";
export default {
    name: 'DataRepoStructureNodeRow',
    props: ['node', 'edit', 'lockSave', 'commonObjects'],
    components: {
        CommonObjectItemPicker,
        CommonObjectItemInfo
    },
    data: () => ({
        value: null,
        inputFocused: false,
        objMenOpen: false
    }),

    computed: {
        classObject() {
            return {
                'sitebook-raw-value-input': true,
                'item-set': this.value.item_id != -1,
            };
        }
    },

    methods: {
        getNodeRawValue: function(node) {
            return node.value.node_value;
        },

        getNodeItemValue: function(node) {
            return node.value.node_value;
        },

        setValueToCommonObjectItem: function(itemNodeValueObj) {
            this.$props.node.value = itemNodeValueObj;
            this.value = this.$props.node.value;
            this.objMenOpen = false;
        },

        nodeInputClearButtonClick: function(val) {
            if(this.value.item_id != -1) {
                this.clearCommonObjectItem();
            }
        },

        clearCommonObjectItem: function() {
            this.$props.node.value = {
                item_id: -1,
                node_id: this.$props.node.node_id,
                node_value: '',
                object_id: -1
            };
            this.value = this.$props.node.value;
            this.objMenOpen = false;
        },

        setValues: function() {
            if(this.$props.node.value) {
                this.value = this.$props.node.value;
            }
            else {
                this.$props.node.value = {
                    item_id: -1,
                    node_id: this.$props.node.node_id,
                    node_value: '',
                    object_id: -1
                };
                this.value = this.$props.node.value;
            }
        },

        openNodeFileBank: function() {
            if(!this.$props.lockSave || this.$props.node.files.length) {
                this.$emit('files');
            }
        }
    },

    created() {
        this.setValues();
    },

    mounted() {
    },

    watch: {
        edit: {
            handler(newVal, oldVal) {
                this.setValues();
            },
        },

    },

  
};
</script>

<style scoped>

    .active {
        color: #FFFF99;
        font-weight: bold;
    }

    .sitebook-node-item-value {
        cursor: pointer;
        text-decoration: underline;
        color: #00ffff;
    }

    .sitebook-raw-value-input {
        padding-top: 0px;
        margin-top: 0px;
        min-height: 30px;
        height: 30px;
    }

    .sitebook-raw-value-input .item-set {
        color: #00ffff;
    }

    .node-files-text {
        color: #FFFF99;
        cursor: pointer;
    }
    .node-files {
        text-align: left;
        font-size: 18px;
        color: #FFFF99;
    }

</style>

<style>

    .sitebook-raw-value-input .v-input__slot {
        min-height: 30px !important;
        height: 30px !important;
    }

    .sitebook-raw-value-input.item-set input {
        color: #00ffff !important;
        text-decoration: underline;
    }

    .sitebook-raw-value-input .v-input__icon--clear {
        margin-top: 4px !important;
        margin-top: -3px !important;
    }

</style>
